import { FC, useEffect, useState } from 'react';
import { Control, Controller, FieldError, FieldErrorsImpl, FieldValues, Merge } from 'react-hook-form';
import ReactDatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import it from 'date-fns/locale/it';
import { format } from 'date-fns';
import { FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/react';

interface Props {
    value: string;
    onChangeProp: (value: string) => void;
    id: string;
    control: Control<FieldValues>;
    label: string;
    flex?: number;
    isRequired?: boolean;
    isInvalid?: FieldError | Merge<FieldError, FieldErrorsImpl<any>> | null;
    dateFormat?: string;
    hasMinDate?: boolean;
    hasFullWidth?: boolean;
}

const DatePickerComponent: FC<Props> = ({
    onChangeProp,
    id,
    control,
    label,
    flex = 1,
    isRequired = false,
    isInvalid = null,
    dateFormat = 'MM/yyyy',
    hasMinDate = true,
    hasFullWidth = false,
}) => {
    const [error, setError] = useState('');

    useEffect(() => {
        if (isInvalid?.message) {
            setError(isInvalid?.message as string);
        } else {
            setError('');
        }
    }, [isInvalid]);

    registerLocale('it', it);

    return (
        <FormControl flex={flex} variant="floating" paddingBottom="20px" isInvalid={isInvalid !== null}>
            <Controller
                name={id}
                control={control}
                rules={{ required: isRequired ? 'Questo campo è obbligatorio' : false }}
                render={({ field: { onChange, onBlur, value } }) => (
                    <ReactDatePicker
                        wrapperClassName={`gattinoni_datePicker ${value ? 'filled' : ''} ${
                            hasFullWidth ? 'fullWidth' : ''
                        }`}
                        className={isInvalid ? 'not-valid' : ''}
                        onChange={(date) => {
                            onChange(date);
                            if (date) {
                                onChangeProp(format(date, dateFormat));
                            }
                        }}
                        onBlur={onBlur}
                        selected={value}
                        dateFormat={dateFormat}
                        showMonthYearPicker={dateFormat === 'MM/yyyy'}
                        showFullMonthYearPicker
                        showTwoColumnMonthYearPicker
                        minDate={hasMinDate ? new Date() : undefined}
                        locale={it}
                    />
                )}
            />
            <FormLabel htmlFor={id}>
                {label}
                {isRequired ? '*' : ''}
            </FormLabel>
            <FormErrorMessage position="absolute" fontSize={12}>
                {error}
            </FormErrorMessage>
        </FormControl>
    );
};

export default DatePickerComponent;
